const s = (t) => {
  if (t === null || typeof t != "object" || Array.isArray(t) || "oneOf" in t || "anyOf" in t || "allOf" in t || "not" in t)
    return !1;
  const r = "type" in t;
  if (r && Array.isArray(t.type))
    return t.type.includes("object");
  const n = r && t.type === "object";
  if (n)
    return !0;
  if (r && !n)
    return !1;
  const i = "properties" in t, o = "additionalProperties" in t, e = "patternProperties" in t;
  return i || o || e;
};
export {
  s as isTypeObject
};
